import LineChartElement from "@/views/elements/chart/LineChartElement";
import TypographyElement from "@/views/elements/typography/TypographyElement";
import classNames from 'classnames/bind';
import { useEffect, useState } from "react";
import styles from './InvestmentEfficiencyChart.module.scss';
import { Stack } from "@mui/system";
import { useTheme } from "@mui/material";
import StateMenu from "@/views/components/StateMenu/StateMenu";
import { useTranslation } from "react-i18next";
import { getInvestPerformancePrivate, getInvestPerformancePublic } from "@/controllers/gridManager/followerTransManager/followerTransManager";

const cx = classNames.bind(styles);

type Props = {
    fullWidth?: boolean
    accountId: string
    masterAccount?: string
    cosrole: string
    isPrivate?: boolean
}

export type TimeRanges = '1-M' | '3-M' | '6-M' | '1-Y'

export default function InvestmentEfficiencyChart({ fullWidth, accountId, cosrole, masterAccount, isPrivate, }: Props) {
    const { t } = useTranslation()
    const theme = useTheme()
    const [dataSeries, setDataSeries] = useState<any>([])
    const [timeRange, setTimeRange] = useState<TimeRanges>('1-M');

    useEffect(() => {
        async function callApiDataChart() {
            const [timePeriod, timeType] = timeRange.split('-')
            const func = isPrivate === true ? getInvestPerformancePrivate : getInvestPerformancePublic
            const { isSuccess, data } = await func(accountId, masterAccount, cosrole, Number.parseInt(timePeriod), timeType)
            const rs = data
            if (isSuccess) {

                console.log('ha_check_datacallApiDataChart', data);
                setDataSeries(rs)
            }
        }
        setDataSeries([])
        callApiDataChart()
    }, [timeRange, masterAccount])

    return (
        <Stack spacing='15px' p='20px' className={fullWidth === true ? cx("line-chart", "full-width") : cx("line-chart")}>
            <TypographyElement className={cx("title-chart")}>
                {t('copytrade.chart.investPerforment')}
            </TypographyElement>
            <StateMenu currentState={timeRange} onStateChange={setTimeRange} menu={[
                { value: '1-M', label: t('copytrade.chart.timeRange.1m') },
                { value: '3-M', label: t('copytrade.chart.timeRange.3m') },
                { value: '6-M', label: t('copytrade.chart.timeRange.6m') },
                { value: '1-Y', label: t('copytrade.chart.timeRange.1y') },
            ]} />
            <div className={cx("img-line-chart")}>
                <LineChartElement
                    series={[
                        {
                            id: 'ar_index',
                            color: theme.palette.chart?.yellowGreen,
                            marker: {
                                enabled: false
                            },
                            name: "VNINDEX"
                        },
                        {
                            id: 'ar',
                            color: theme.palette.chart?.blue,
                            marker: {
                                enabled: false
                            },
                            name: t('copytrade.chart.investPerforment')
                        }
                    ]}
                    dataSeries={dataSeries}
                    height={null}
                    width={null}
                    timeRange={timeRange}
                    isShowYAxis={true}
                    isShowXAxis={true}
                    isShowLegend={true}

                    numberDecimal={2}
                />
            </div>
        </Stack>
    )
}